<template>
  <v-dialog v-model="open" persistent max-width="490px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block color="primary" dark v-bind="attrs" v-on="on">
        OUTBOUND VM
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">#2 VoiceMails</span>
      </v-card-title>
      <v-card-text>
        <v-container class="d-flex">
          <v-file-input
            v-model="audioFile"
            type="file"
            show-size
            label="Upload the audio file"
            accept="audio/*"
            truncate-length="50"
          ></v-file-input>
          <v-btn color="blue darken-1" @click="create" dark>Upload</v-btn>
        </v-container>

        <template ref="voiceMailRecords">
          <v-row
            class="d-flex justify-center align-center"
            v-for="voicemail in voicemails"
            :key="voicemail.id"
          >
            <v-btn color="red" @click="deleteItem(voicemail.id)" dark
              >remove</v-btn
            >
            <audio controls>
              <source :src="apiUrl + voicemail.url" />
            </audio>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "ResponseVoiceMailsForm",
  data() {
    return {
      open: false,
      audioFile: null,
      apiUrl: process.env.VUE_APP_API_LINK + "/",
    };
  },
  methods: {
    ...mapMutations({
      addNewVoiceMails: "voicemails/ADD_NEW_VOICEMAIL",
      deleteVoiceMails: "voicemails/DELETE_VOICEMAIL",
    }),
    ...mapActions({
      getVoiceMails: "voicemails/getVoiceMails",
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    create() {
      let formData = new FormData();
      formData.append("user_id", this.user.id);
      formData.append("audio", this.audioFile);

      this.$axios
        .post("/voicemail/create", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.addNewVoiceMails(res.data.vm);
          this.$refs.voiceMailRecords.load();
        })
        .catch((err) => {
          console.log(err);
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
    deleteItem(id) {
      this.$axios
        .post("/voicemail/delete", {
          recordId: id,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.deleteVoiceMails(id);
        })
        .catch((err) => {
          console.log(err);
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
  },
  created() {
    this.getVoiceMails(this.user.id);
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      voicemails: "voicemails/voicemails",
    }),
  },
};
</script>

<style>
</style>